module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_07.2e9c0d6e.jpg";